module.exports = __webpack_public_path__ + "img/EXTERIOR-S-CROSS-4.75b3a261.jpg";